import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-49ef5340"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "course-item__wrapper" }
const _hoisted_2 = { class: "course-item__img-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "course-item__img course-item__img--placeholder"
}
const _hoisted_5 = {
  key: 2,
  class: "course-item__crumb"
}
const _hoisted_6 = {
  key: 0,
  class: "course-item__crumb-icon",
  src: "/assets/icon/battery-icon.svg"
}
const _hoisted_7 = {
  key: 0,
  class: "course-item__description"
}
const _hoisted_8 = {
  key: 1,
  class: "course-item__meta"
}
const _hoisted_9 = {
  key: 0,
  class: "course-item__meta-item"
}
const _hoisted_10 = {
  key: 1,
  class: "course-item__meta-item"
}
const _hoisted_11 = {
  key: 2,
  class: "course-item__meta-item"
}
const _hoisted_12 = {
  key: 3,
  class: "course-item__meta-item"
}

import { computed, ref } from 'vue';
import { CourseI } from '@/types';
import { getFirebaseImagePath } from '@/services/methods';

import { IonIcon } from '@ionic/vue';
import api from '@/api';
import { useUserStore } from '@/stores/user';
import { useInternalization } from '@/composables/useInternalization';


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseItem',
  props: {
    course: {},
    mini: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const thumbnailDownloadUrl = ref('');
const themeName = ref('');

const userStore = useUserStore();
const { t, locale } = useInternalization();

const metaTheoryLessonsCount = computed(
  () =>
    props.course.videoItems.filter((video) => video.type === 'theory').length
);
const metaPracticeLessonsCount = computed(
  () =>
    props.course.videoItems.filter((video) => video.type === 'practice').length
);
const metaFirstAidLessonsCount = computed(
  () =>
    props.course.videoItems.filter((video) => video.type === 'first aid').length
);

const progressStatus = computed(() => {
  const userCourse = userStore.user.therapyCourses?.find(
    (c) => c.id === props.course.id
  );
  if (userCourse) {
    return {
      title: userCourse.isFinished ? t('finished') : t('inProgress'),
      value: userCourse.isFinished ? 'Finished' : 'In progress',
    };
  }
  return null;
});

async function getThumbnailUrl() {
  thumbnailDownloadUrl.value = await getFirebaseImagePath(
    props.course.thumbnailUrl
  );
}
async function getTheme() {
  const theme = await api.themes.getById(props.course.themeId);
  const name = theme.translations[locale.value]?.name || theme.name;
  themeName.value = name || '';
}
getThumbnailUrl();
getTheme();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['course-item', { 'course-item--mini': _ctx.mini }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (thumbnailDownloadUrl.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "course-item__img",
              src: thumbnailDownloadUrl.value,
              style: _normalizeStyle({ marginBottom: _ctx.mini ? '0px' : '10px' })
            }, null, 12, _hoisted_3))
          : (_openBlock(), _createElementBlock("div", _hoisted_4)),
        (themeName.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(themeName.value), 1))
          : _createCommentVNode("", true),
        (progressStatus.value && !_ctx.mini)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass([
            'course-item__crumb',
            'course-item__crumb--status',
            {
              'course-item__crumb--green': progressStatus.value.value === 'Finished',
            },
            {
              'course-item__crumb--blue':
                progressStatus.value.value === 'In progress',
            },
          ])
            }, [
              _createTextVNode(_toDisplayString(progressStatus.value.title) + " ", 1),
              (progressStatus.value.value === 'In progress')
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.mini)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.course.description), 1))
        : _createCommentVNode("", true),
      (!_ctx.mini)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (metaTheoryLessonsCount.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_unref(IonIcon), { icon: "/assets/icon/book-icon.svg" }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('theoryLessons', { n: metaTheoryLessonsCount.value })), 1)
                ]))
              : _createCommentVNode("", true),
            (metaPracticeLessonsCount.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_unref(IonIcon), { icon: "/assets/icon/pen-icon.svg" }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('practicalExercises', { n: metaPracticeLessonsCount.value })), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.course.timesPerDay)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_unref(IonIcon), { icon: "/assets/icon/alarm-icon.svg" }),
                  _createTextVNode(" " + _toDisplayString(_ctx.course.timesPerDay) + " " + _toDisplayString(_unref(t)('perDay')), 1)
                ]))
              : _createCommentVNode("", true),
            (metaFirstAidLessonsCount.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_unref(IonIcon), { icon: "/assets/icon/med-icon.svg" }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('firstAidKitVideos', { n: metaFirstAidLessonsCount.value })), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})